
import { Watch, Component, Vue, Prop, toNative, mixins } from 'vue-facing-decorator'
@Component({
  // 声明后 update:modelValue 不再进入 $attrs，
  // 否则会被 v-bind="$attrs" 透传给 el-input，绕过下面的 validate 拦截
  emits: ["update:modelValue"],
})
export default class extends Vue {

  @Prop({})
  modelValue: any

  @Prop({})
  validate: any

  @Watch('modelValue')
  modelValueWather(val) {
    this.modelValue_ = val;
  }

  modelValue_ = ''
  created(): void {
    this.modelValue_ = this.modelValue
  }
  inputValue(val) {
    if (val != "") {
      switch (this.validate) {
        case "coin":
          if (
            !/^(([1-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/.test(
              val
            )
          ) {
            return;
          }
          break;
        // 非负整数
        case "int":
          if (!/^\d*$/.test(val)) {
            return;
          }
          break;
        // 非负数字，最多两位小数
        case "decimal":
          if (!/^\d*(\.\d{0,2})?$/.test(val)) {
            return;
          }
          break;
      }
    }
    this.modelValue_ = val;
    this.$emit("update:modelValue", val);
  }

}

